import React, { Fragment } from 'react'
import { Button } from 'src/chrome'

interface Props {
  onSave: () => void
  saveButtonLabel: string
  label?: JSX.Element | null
  secondaryAction?: {
    label: string
    onClick: () => void
  }
}

const EditorFooterContents: React.FC<Props> = props => {
  const { label = null, saveButtonLabel, onSave, secondaryAction } = props

  return (
    <Fragment>
      <div css={{ paddingLeft: 15 }}>{label}</div>
      <div css={{ display: 'flex', paddingRight: 15, alignItems: 'center' }}>
        {secondaryAction && (
          <Button
            id={'editor_secondary_action_btn'}
            title={secondaryAction.label}
            style={{ marginRight: 15 }}
            onClick={() => secondaryAction.onClick()}
          />
        )}
        <Button
          id={'editor_primary_action_btn'}
          buttonColor={'pink'}
          title={saveButtonLabel}
          style={{ marginRight: 15 }}
          onClick={() => onSave()}
        />
      </div>
    </Fragment>
  )
}

export default EditorFooterContents
